import * as http from "../../index";
import Configuration from "../../../config/index";
import { createRequest } from "./utils";
export const getUrl = (orderRef) => {
    const host = Configuration.current().getApiAddress();
    const url = `${host}/bankid/collect/${orderRef}`;
    return url;
};
export const collect = (requestOptions) => {
    const url = getUrl(requestOptions.orderRef);
    const request = createRequest();
    return http.captureStateContext(http.json(url, request));
};
